// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bdb3baaf","186":"1af83f01","225":"b6e480c6","344":"1765ef35","372":"90fb0515","443":"3c83dc5d","596":"c94821c2","738":"112df6f0","787":"50bb031f","841":"9ec3e037","856":"8084116d"}[chunkId] + ".chunk.js";
};